import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '../utils/cn';

function StatCard({ icon: Icon, tone = 'brand', label, value, delta, deltaLabel, suffix }) {
  const trend =
    delta == null ? 'flat' : delta > 0 ? 'up' : delta < 0 ? 'down' : 'flat';
  const Trend = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : Minus;

  return (
    <div className="stat-card">
      {Icon && (
        <div className={cn('stat-icon', tone)}>
          <Icon size={20} />
        </div>
      )}
      <div style={{ minWidth: 0 }}>
        <div className="stat-label">{label}</div>
        <div className="stat-value">
          {value}
          {suffix && <span style={{ fontSize: 14, color: 'var(--text-muted)', marginLeft: 6 }}>{suffix}</span>}
        </div>
        {(delta != null || deltaLabel) && (
          <div className={cn('stat-delta', trend)}>
            <Trend size={14} />
            {delta != null && <span>{delta > 0 ? '+' : ''}{delta}%</span>}
            {deltaLabel && <span style={{ color: 'var(--text-muted)' }}>· {deltaLabel}</span>}
          </div>
        )}
      </div>
    </div>
  );
}

export default StatCard;
